

import { MailListComponent } from "./mail-list/mail-list.component";
import {LetterDetailWrapperComponent} from "./letter-detail-wrapper/letter-detail-wrapper.component";

export const LETTERS_ROUTES: any = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: MailListComponent },
    { path: ":id", component: LetterDetailWrapperComponent },
    { path: ":id/:flowId", component: LetterDetailWrapperComponent },
]